import { createContext } from 'react';

import type { RoverBrandContextType } from '@rover/types/src/RoverBrand';

const RoverBrandContext = createContext<RoverBrandContextType | null>(null);

export default RoverBrandContext;
